import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'
import { useMemo } from 'use-memo-one'

import { NumericFormat } from '@blade/std-lib'
import { NumericInput } from '@blade/ui-kit'

import type { DistributeTargetModel } from '../../../atoms/reatom-distribute-target'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  target: DistributeTargetModel
} & ClassNameProps

export const WalletDestinationPercentageInput: React.FC<Props> = ({
  target,
}) => {
  const [rawPercentage] = useAtom(target.percentageAtom.raw)
  const setRawPercentage = useAction(target.setPercentageAction)
  const [source] = useAtom(target.inputSource)
  const [resolvedPercentage] = useAtom(target.resolvedPercentage)

  const percentageToRender = useMemo(() => {
    if (source === 'percentage') {
      return rawPercentage
    }
    return NumericFormat.formatPreset(resolvedPercentage, 'percents')
  }, [source, resolvedPercentage, rawPercentage])

  return (
    <Root>
      <Measurer>
        <span>{percentageToRender}</span>
        <Input
          min={0}
          max={100}
          isAllowed={({ floatValue }) => {
            return floatValue === undefined || floatValue <= 100
          }}
          value={percentageToRender}
          onChange={(e) => setRawPercentage(e.target.value)}
        />
      </Measurer>
      <div>%</div>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  gap: 1px;
`
const Input = styled(NumericInput)`
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  border: none;
  padding: 0;
  background: transparent;

  text-align: right;
  color: var(--primary-9);
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;

  &::placeholder {
    color: var(--primary-9);
  }
`
const Measurer = styled.div`
  position: relative;
  display: inline-block;
  min-width: 1ch;
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  height: 16px;
  color: transparent;
`
